import React, { memo } from 'react';
import { useComment } from './components/CommentProvider';
import { Avatar, Tooltip } from 'antd';

const UsersDisplayCount = 10;

const getCapital = (str) => {
  const arr = str.split(' ');
  if (arr.length === 1) {
    return arr[0].slice(0, 1);
  }
  return `${arr[0].slice(0, 1)}${arr[arr.length - 1].slice(0, 1)}`;
};

const ProjectUsers = () => {
  const commentContext = useComment();
  const { selfEmail, projectUsersWithInfo: users } = commentContext || {};
  const projectUsersWithInfo = (users || []).slice().sort((a, b) => {
    if (a.isClient !== b.isClient) {
      return a.isClient ? 1 : -1;
    }
    return getCapital(a.fullName) < getCapital(b.fullName) ? -1 : 1;
  });
  return (
    <div className="project-user-avators">
      {[
        ...projectUsersWithInfo
          .filter((user) => user.email !== selfEmail)
          .slice(0, UsersDisplayCount)
          .map((p, index) => (
            <Tooltip
              overlayClassName="no-arrow-tooltip"
              title={p.fullName}
              placement="bottomLeft"
              key={index}
            >
              <Avatar
                className={`project-user-avator ${
                  p.isClient ? 'client-user' : 'internal-user'
                }`}
              >
                {getCapital(p.fullName)}
              </Avatar>
            </Tooltip>
          )),
        // Minus One means ignore the cur user

        projectUsersWithInfo.length > 1 ? (
          <Tooltip
            key="more-users-avatar"
            trigger="click"
            overlayClassName="all-project-users-overlay"
            title={projectUsersWithInfo.map((item, index) => (
              <div key={index} className="user-in-all-users-dropdown">
                {item.fullName}
                {item.isClient ? '' : ' (PwC)'}
              </div>
            ))}
            placement="bottomLeft"
          >
            <Avatar className="project-user-avator more-users">
              {projectUsersWithInfo.length - 1 > UsersDisplayCount ? (
                `+${projectUsersWithInfo.length - 1 - UsersDisplayCount}`
              ) : (
                <span className="appkiticon icon-horizontal-more-fill" />
              )}
            </Avatar>
          </Tooltip>
        ) : null,
      ].reverse()}
    </div>
  );
};
export default memo(ProjectUsers);
